import React, { useEffect } from "react";
import styled from "styled-components";
import plus from '../../assets/plus.svg';


const Button = styled.a`
    padding: 8px 16px;
    border-radius: 10000px;
    font-size: 14px;
    border: 1px solid;
    border-color: #59C5E8;
    height: 17px;
    display: flex;
    position: absolute;
    right: 13px;
    top: 0px;
`;

export default function FollowButton({openModal}){
    return (
      <>
        <Button onClick={() => openModal()}>
            <img src={plus} />
            <label style={{marginLeft: 8}}>Follow</label>
        </Button>        
      </>
    );
  };